export default __webpack_public_path__ + "static/media/caret-up-white.f0cc1e85.svg";